// import PropTypes from 'prop-types';
// // @mui
// import { styled } from '@mui/material/styles';
// import { List, Box, ListSubheader } from '@mui/material';
// //
// import { NavListRoot } from './NavList';

import { Box, List, ListSubheader, styled } from "@mui/material";
import { NavListRoot } from "./navList";
import { NavConfig } from "./navItem";

// export const ListSubheaderStyle = styled(ListSubheader)(
//   ({ theme }) => ({
//     ...theme.typography.overline,
//     paddingTop: theme.spacing(3),
//     paddingLeft: theme.spacing(2),
//     paddingBottom: theme.spacing(1),
//     color: theme.palette.text.primary,
//     transition: theme.transitions.create('opacity', {
//       duration: theme.transitions.duration.shorter,
//     }),
//   })
// );


interface Props{
  navConfig: NavConfig;
}

export default function NavSectionVertical({ navConfig, ...other } : Props) {
  return (
    <Box {...other}>
      {navConfig.map((group) => (
        <List key={group.subheader} disablePadding sx={{ px: 2 }}>
          {/* <ListSubheaderStyle>
            {group.subheader}
          </ListSubheaderStyle> */}

          {group.items.map((list) => (
            <NavListRoot key={list.title} list={list} />
          ))}
        </List>
      ))}
    </Box>
  );
}
